import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmployeeType } from "src/models/Stores/Employee.models";

interface EmployeeTypeState {
  employeeTypes: IEmployeeType[];
  employeeTypeToEdit: IEmployeeType | null;
}

const initialState: EmployeeTypeState = {
  employeeTypes: [],
  employeeTypeToEdit: null,
};

const employeeTypeSlice = createSlice({
  name: "EmployeeType",
  initialState,
  reducers: {
    setEmployeeTypeList: (state, action: PayloadAction<IEmployeeType[]>) => {
      state.employeeTypes = action.payload;
    },
    concatListEmployeeType: (
      state: EmployeeTypeState,
      action: PayloadAction<IEmployeeType[]>
    ) => {
      state.employeeTypes = [...state.employeeTypes.concat(action.payload)];
    },
    setEmployeeTypeToEdit: (
      state,
      action: PayloadAction<IEmployeeType | null>
    ) => {
      state.employeeTypeToEdit = action.payload;
    },
    addEmployeeType: (state, action: PayloadAction<IEmployeeType>) => {
      state.employeeTypes.push(action.payload);
    },
    updateEmployeeType: (state, action: PayloadAction<IEmployeeType>) => {
      let itemIndex = state.employeeTypes.findIndex(
        item => item.employeeTypeId === action.payload.employeeTypeId
      );
      if (itemIndex !== -1) state.employeeTypes[itemIndex] = action.payload;
    },
    deleteEmployeeType: (state, action: PayloadAction<number>) => {
      const newArray = state.employeeTypes.filter(
        item => item.employeeTypeId !== action.payload
      );
      state.employeeTypes = newArray;
    },
  },
});

export const {
  setEmployeeTypeList,
  concatListEmployeeType,
  setEmployeeTypeToEdit,
  addEmployeeType,
  updateEmployeeType,
  deleteEmployeeType,
} = employeeTypeSlice.actions;

export default employeeTypeSlice.reducer;
